import React from 'react'
import { Card, Dropdown, ListGroup } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CardHeader from '../../common/card/CardHeader'
import { useAppDispatch } from '../../../store/store'
import {
  useLazyGetNotificationsQuery,
  useMarkAsReadMutation,
} from '../../../store/kopiliot-api/notification'
import { SortOrderDirection } from '../../../store/kopiliot-api/query-type'
import dayjs from 'dayjs'
import ViewNotification from '../../../features/notifications/modal/ViewNotification'
import { NotificationID } from '../../../shared/models/id/notification_id'

const KopiliotNotificationCenter = (): JSX.Element => {
  const navigate = useNavigate()
  // get the number of unread notifications
  const totalUnreadCount = 0
  const [isOpen, setIsOpen] = React.useState(false)
  const [isAllRead, setIsAllRead] = React.useState(false)
  const [currentNotification, setCurrentNotification] = React.useState<
    NotificationID | undefined
  >()
  const [getNotifications, resultNotifications] = useLazyGetNotificationsQuery()
  const [markAsRead, resultMarkAsRead] = useMarkAsReadMutation()
  const dispatch = useAppDispatch()

  // Handler
  const handleToggle = () => {
    setIsOpen(!isOpen)
  }

  React.useEffect(() => {
    window.addEventListener('scroll', () => {
      window.innerWidth < 1200 && setIsOpen(false)
    })
  }, [])

  React.useEffect(() => {
    const interval = setInterval(() => {
      getNotifications({
        offset: 0,
        limit: 20,
        sortOrder: {
          direction: SortOrderDirection.DESC,
          property: 'createdAt',
        },
        textSearch: '',
        status: 'SENT',
      })
    }, 8000)

    return () => clearInterval(interval)
  }, [])

  const markNotificationAsRead = (e: any) => {
    e.preventDefault()

    /*const updatedNewNotifications = data?.map((notification) =>
      Object.prototype.hasOwnProperty.call(notification, 'unread')
        ? { ...notification, unread: false }
        : notification
    )*/

    setIsAllRead(true)
  }
  return (
    <>
      <ViewNotification
        id={currentNotification}
        show={currentNotification != undefined}
        onHide={() => {
          setCurrentNotification(undefined)
        }}
      />
      <Dropdown navbar={true} as="li" show={isOpen} onToggle={handleToggle}>
        <Dropdown.Toggle
          bsPrefix="toggle"
          as={Link}
          to="#!"
          className={classNames('px-0 nav-link', {
            'notification-indicator notification-indicator-primary':
              totalUnreadCount > 0,
          })}
        >
          <div
            className={classNames('px-0', {
              'notification-indicator notification-indicator-danger position-relative notification-indicator-fill':
                resultNotifications.data?.rows.length,
            })}
          >
            <span className="notification-indicator-number">
              {resultNotifications.data?.rows.length}
            </span>
            <FontAwesomeIcon
              icon="bell"
              transform="shrink-6"
              className="fs-4"
            />
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="dropdown-menu-card dropdown-menu-end dropdown-caret dropdown-caret-bg">
          <Card
            className="dropdown-menu-notification dropdown-menu-end shadow-none"
            style={{ maxWidth: '20rem' }}
          >
            <CardHeader
              className="card-header"
              title="Notifications"
              titleTag="h6"
              light={false}
              endEl={
                <Link
                  className="card-link fw-normal"
                  to="#!"
                  //onClick={markAsRead}
                >
                  Tout marquer comme lu
                </Link>
              }
            />
            <ListGroup
              variant="flush"
              className="fw-normal fs--1 scrollbar"
              style={{ maxHeight: '19rem' }}
            >
              <>
                <div className="list-group-title">Nouvelles</div>{' '}
                {resultNotifications.data?.rows.map((item) => {
                  return (
                    <ListGroup.Item key={item.id?.id} onClick={handleToggle}>
                      <div
                        className={classNames(
                          'notification  notification-flush rounded-0 border-x-0 border-300 border-bottom-0 cursor-pointer',
                          {
                            'notification-unread': item.status != 'READ',
                          }
                        )}
                        onClick={() => setCurrentNotification(item.id)}
                      >
                        <div className="notification-body w-100">
                          <div
                            className={
                              'd-flex flex-row justify-content-between'
                            }
                          >
                            <div>
                              <p className="mb-1">
                                <strong>{item.subject}</strong>
                              </p>
                              <span className="notification-time">
                                <span className="me-2">{item.body}</span>
                                <p>
                                  {dayjs(item.createdAt).format(
                                    'DD/MM/YYYY HH:mm'
                                  )}
                                </p>
                              </span>
                            </div>
                            <div
                              className={'cursor-pointer'}
                              onClick={(e) => {
                                e.stopPropagation()
                                item.id && markAsRead(item.id)
                              }}
                            >
                              <FontAwesomeIcon
                                icon={
                                  item.status == 'READ' ? 'eye-slash' : 'eye'
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </ListGroup.Item>
                  )
                })}
              </>
            </ListGroup>
            <div
              className="card-footer text-center border-top"
              onClick={handleToggle}
            >
              <Link
                className="card-link d-block"
                to="/notification-center/inbox"
              >
                Voir toutes les notifications
              </Link>
            </div>
          </Card>
        </Dropdown.Menu>
      </Dropdown>
    </>
  )
}

export default KopiliotNotificationCenter
